import { render, staticRenderFns } from "./TypeItem.vue?vue&type=template&id=7151a8a2&scoped=true&"
import script from "./TypeItem.vue?vue&type=script&lang=js&"
export * from "./TypeItem.vue?vue&type=script&lang=js&"
import style0 from "./TypeItem.vue?vue&type=style&index=0&id=7151a8a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7151a8a2",
  null
  
)

export default component.exports